import { gql } from "@apollo/client"

export const DeleteBlog = gql`
mutation DeleteBlog($deleteBlogId: ID!) {
  deleteBlog(id: $deleteBlogId) {
    status
  }
}
`